import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Container from '@material-ui/core/Container';
import Typography from 'material-ui/styles/typography';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { borderRadius } from '@mui/system';
import { Button, Link } from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';
import SchoolIcon from '@mui/icons-material/School';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import WebIcon from '@mui/icons-material/Web';
import BarChartIcon from '@mui/icons-material/BarChart';
import GitHubIcon from '@mui/icons-material/GitHub';
import ShopIcon from '@mui/icons-material/Shop';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import AppsIcon from '@mui/icons-material/Apps';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PsychologyIcon from '@mui/icons-material/Psychology';
import NotesIcon from '@mui/icons-material/Notes';
import { motion } from 'framer-motion/dist/framer-motion'


function History() {

  const { t } = useTranslation();
  const useStyles = makeStyles((theme) => ({
    history: {
      paddingTop: "350px",
      paddingBottom: "70px",

      "@media (max-width: 550px)": {
        paddingTop: "150px",
      }
    },
    title: {
      textAlign: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      borderRadius: '200px',
      textShadow: '1px 1px 1px black',
      color: 'white',
      fontSize: '50px',

      "@media (max-width: 550px)": {
        fontSize: '35px',
      }
    },
    link: {
      textDecoration: 'underline',
      textShadow: '1px 1px 1px black',
      color: 'white'
    },
    date: {
      color: 'white',
      textShadow: '2px 2px 2px  black',
      fontSize: '50px',
      textDecoration: 'underline'

    },
    icon: {

      borderRadius: '20px',

    },
    back: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      borderRadius: '30px',


      "@media (max-width: 550px)": {
        borderRadius: '0px',

      }
    },
    buttons: {
      paddingBottom: '20px'
    },
    marginleft: {
      marginLeft: '10px',
      marginRight: '7px',
      "@media (max-width: 550px)": {
        marginLeft: '0px',

      }

    },
    switch: {
      transform: 'scale(1.3)',
      "@media (max-width: 550px)": {
        transform: 'scale(1)',

      }
    }

  }));









  const classes = useStyles();


  const [checked, setChecked] = React.useState(true);

  const handleChange = () => {
    setChecked((prev) => !prev);
  };


  const HistoryData = [
    {
      id: 1,
      timeline_element: 'work',
      background: '#8800bd',
      date: t('date_1'),
      icon: <SportsEsportsIcon />,
      timeline_title: t('timeline_title_1'),
      timeline_desc: t('timeline_desc_1'),
      button_name: 'Setup',
      button_href: 'https://www.youtube.com/playlist?list=PLNqXCU1DLgu2ovHftUN4NFBNJZksBm9HA',
      button_color: 'violet',
      button_icon: <YouTubeIcon />
    },
    {
      id: 2,
      timeline_element: 'work',
      background: 'darkgreen',
      date: t('date_2'),
      icon: <AndroidIcon />,
      timeline_title: t('timeline_title_2'),
      timeline_subtitle: t('timeline_subtitle_2'),
      timeline_desc: t('timeline_desc_2'),
      button_name: 'KomaQuiz',
      button_href: 'https://play.google.com/store/apps/details?id=komar.corporation.Quiz&hl=ru',
      button_color: 'green',
      button_icon: <ShopIcon />
    },
    {
      id: 3,
      timeline_element: 'education',
      background: '#2e2e2e',
      date: t('date_3'),
      icon: <SchoolIcon />,
      timeline_title: t('timeline_title_3'),
      timeline_subtitle: t('timeline_subtitle_3'),
      timeline_desc: t('timeline_desc_3'),
      button_name: 'Github',
      button_href: 'https://github.com/Ivan-Corporation?after=Y3Vyc29yOnYyOpK5MjAyMS0wNC0xNFQyMDo0MDoxNCswNzowMM4TmEIP&tab=repositories',
      button_color: 'black',
      button_icon: <GitHubIcon />
    },
    {
      id: 4,
      timeline_element: 'education',
      background: '#00aad9',
      date: t('date_4'),
      icon: <WebIcon />,
      timeline_title: t('timeline_title_4'),
      timeline_subtitle: t('timeline_subtitle_4'),
      timeline_desc: t('timeline_desc_4'),
      button_name: 'Old repo',
      button_href: 'https://github.com/Ivan-Corporation/Battleship-game',
      button_color: 'lightblue',
      button_icon: <GitHubIcon />
    },
    {
      id: 5,
      timeline_element: 'education',
      background: '#c90d00',
      date: t('date_5'),
      icon: <WebIcon />,
      timeline_title: t('timeline_title_5'),
      timeline_subtitle: t('timeline_subtitle_5'),
      timeline_desc: t('timeline_desc_5'),
      button_name: 'Youtube',
      button_href: 'https://www.youtube.com/channel/UCWj8NJUnyji2xHHThU1TTsw',
      button_color: 'red',
      button_icon: <YouTubeIcon />
    },
    {
      id: 6,
      timeline_element: 'education',
      background: '#595959',
      date: t('date_6'),
      icon: <BarChartIcon />,
      timeline_title: t('timeline_title_6'),
      timeline_subtitle: t('timeline_subtitle_6'),
      timeline_desc: t('timeline_desc_6'),
      button_name: 'Frontend',
      button_href: 'https://github.com/Ivan-Corporation/Investing-App',
      button_color: 'gray',
      button_icon: <BarChartIcon />
    },
    {
      id: 7,
      timeline_element: 'education',
      background: 'darkorange',
      date: t('date_7'),
      icon: <EmojiObjectsIcon />,
      timeline_title: t('timeline_title_7'),
      timeline_subtitle: t('timeline_subtitle_7'),
      timeline_desc: t('timeline_desc_7'),
      button_name: 'Komaroad',
      button_href: 'https://komaroad.netlify.app/',
      button_color: 'orange',
      button_icon: <TipsAndUpdatesIcon />
    },
    {
      id: 8,
      timeline_element: 'education',
      background: 'green',
      date: t('date_8'),
      icon: <EngineeringIcon />,
      timeline_title: t('timeline_title_8'),
      timeline_subtitle: t('timeline_subtitle_8'),
      timeline_desc: t('timeline_desc_8'),
      button_name: 'Komtodo / Vue',
      button_href: 'https://komtodo.vercel.app/',
      button_color: 'green',
      button_icon: <ListAltIcon />
    },
    {
      id: 9,
      timeline_element: 'education',
      background: 'black',
      date: t('date_9'),
      icon: <ViewInArIcon />,
      timeline_title: t('timeline_title_9'),
      timeline_subtitle: t('timeline_subtitle_9'),
      timeline_desc: t('timeline_desc_9'),
      button_name: '3D Planet Destroyer',
      button_href: 'https://planet-destroyer.netlify.app/',
      button_color: 'gray',
      button_icon: <TravelExploreIcon />
    },
    {
      id: 10,
      timeline_element: 'education',
      background: 'darkred',
      date: t('date_10'),
      icon: <AppsIcon />,
      timeline_title: t('timeline_title_10'),
      timeline_subtitle: t('timeline_subtitle_10'),
      timeline_desc: t('timeline_desc_10'),
      button_name: 'Libraries',
      button_href: 'https://www.npmjs.com/settings/komahuman/packages',
      button_color: 'darkred',
      button_icon: <AppsIcon />
    },
    {
      id: 11,
      timeline_element: 'education',
      background: 'olive',
      date: t('date_11'),
      icon: <MenuBookIcon />,
      timeline_title: t('timeline_title_11'),
      timeline_subtitle: t('timeline_subtitle_11'),
      timeline_desc: t('timeline_desc_11'),
      button_name: 'Goodreads',
      button_href: 'https://www.goodreads.com/review/list/110297318',
      button_color: 'olive',
      button_icon: <MenuBookIcon />
    },
    {
      id: 12,
      timeline_element: 'education',
      background: '#B7410E',
      date: t('date_12'),
      icon: <PsychologyIcon />,
      timeline_title: t('timeline_title_12'),
      timeline_subtitle: t('timeline_subtitle_12'),
      timeline_desc: t('timeline_desc_12'),
      button_name: 'Kamulet',
      button_href: 'https://github.com/Ivan-Corporation/Kamulet_Roguelike',
      button_color: '#B7410E',
      button_icon: <PsychologyIcon />
    },
    {
      id: 13,
      timeline_element: 'education',
      background: '#e54fe9',
      date: t('date_13'),
      icon: <NotesIcon />,
      timeline_title: t('timeline_title_13'),
      timeline_subtitle: t('timeline_subtitle_13'),
      timeline_desc: t('timeline_desc_13'),
      button_name: 'Komotedly',
      button_href: 'https://github.com/Ivan-Corporation/Komotedly',
      button_color: '#e54fe9',
      button_icon: <NotesIcon />
    },
  ]



  return (
    <>
    <motion.div
                initial={{ opacity: 0, y: -180}}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    ease: "easeInOut",
                    duration: 1,
                    delay:0.3
                }}
                >
   
    <Container className={classes.history}>

      <h1 className={classes.title}> <b><u>{t('my_history')}</u> <br />⇩<Box >
        <FormControlLabel labelPlacement="bottom"
          control={<Switch checked={checked} className={classes.switch} color='warning' onChange={handleChange} />}
          label={t('background')}
        />
      </Box></b></h1>

      <VerticalTimeline className={checked ? classes.back : ''}>

        {HistoryData.map(({ background, date, icon, youtube, github, timeline_desc, timeline_title, timeline_subtitle, button_name, button_href, button_color, button_icon }) => (
          <VerticalTimelineElement
            className={`vertical-timeline-element--{timeline_element}`}
            contentStyle={{ background: `${background}`, color: '#fff', border: '1px solid black' }}
            className={classes.marginleft}
            contentArrowStyle={{ borderRight: `7px solid  ${background}` }}
            date={date}
            dateClassName={classes.date}
            iconStyle={{ background: `${background}`, color: '#fff' }}
            icon={icon}
            iconClassName={classes.icon}

          >

            <h3 className="vertical-timeline-element-title">{timeline_title}</h3><hr />
            <h4 className="vertical-timeline-element-subtitle">{timeline_subtitle}</h4>
            <p className={classes.buttons}>
              {timeline_desc}
            </p>

            <Button style={{ backgroundColor: `${button_color}` }} target='_blank' variant="contained" href={button_href} endIcon={button_icon}>{button_name}</Button><br />

          </VerticalTimelineElement>
        ))}


      </VerticalTimeline>

    </Container>
</motion.div>
    </>
  )
}

export default History